<template>
    <div>
        <div class="bg-[#BD9135] font-bold w-[90%] text-center rounded-[3px] mx-auto text-black py-[5px]">
            СТВОРИТИ ТРЕНУВАННЯ
        </div>

        <div>
            <TrainingForm @saveTraining="saveTraining" />            
        </div>
    </div>
</template>

<script>
    import { ref, watch } from 'vue'
    import { useRouter } from 'vue-router'
    import { addNewTrainingSummary, updateTraining } from '@/desktopApp/services/apiRequests'
    import TrainingForm from './components/TrainingForm.vue'
    
    export default {
        name: 'TrainingCreationForm',

        setup() {
            const router = useRouter()

            const saveTraining = async (newTrainingObject) => {
                const summary = await addNewTrainingSummary(newTrainingObject.training)

                await updateTraining(
                    newTrainingObject.event.training_id,
                    newTrainingObject.event.group_label, 
                    newTrainingObject.event.group_id, 
                    newTrainingObject.event?.location_label, 
                    newTrainingObject.event?.location_id, 
                    newTrainingObject.event.start_time, 
                    newTrainingObject.event.end_time, 
                    newTrainingObject.event.date.split('T')[0],
                    newTrainingObject.event.type,
                    newTrainingObject.event.description,
                    summary
                )

                router.push('/trainings-constructor')
            }

            return {
                saveTraining,
                router
            }
        },

        components: {
            TrainingForm
        }
    }
</script>

<style lang="scss" scoped>

</style>

{ "training_id": "e55998a3-27a6-4107-92c7-a8cde5eb5ef0", "group_id": "68598c10-1e53-4043-a06f-5a9bc9933422", "group_label": "Kolos U15", "date": "2025-10-17T00:00:00", "start_time": "14:00", "end_time": "15:30", "location_id": "55e5a43c-b3d1-4f4b-b2f2-09c134265a28", "location_label": "НТБ Колос", "status": "planed", "type": "championship", "description": null, "trainer_id": null, "summary": null, "match_report_id": null }